import { useEffect } from 'react';
import Spacing from 'components/Spacing';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { getSeriesState } from 'selectors/series';
import { getCuadrosData } from 'selectors/cuadros';
import { getSeries } from 'store/series/actions';
import { getCuadros } from 'store/cuadros/actions';
import { Serie } from './Serie';

export const ArteScreen = () => {
  const dispatch = useAppDispatch();
  const { seriesState, cuadrosData } = useAppSelector(state => ({
    seriesState: getSeriesState(state),
    cuadrosData: getCuadrosData(state),
  }));

  useEffect(() => {
    if (!seriesState.data) dispatch(getSeries());
    if (!cuadrosData) dispatch(getCuadros());
  }, []);

  const seriesConCuadros = cuadrosData?.map(cuadro => cuadro.id_serie);
  const seriesFiltradas = seriesState.data
    ?.filter(serie => seriesConCuadros?.includes(serie.id))
    ?.sort((a, b) => {
      // La serie con id = 10 va primero
      if (a.id === 10) return -1;
      if (b.id === 10) return 1;
      // El resto mantiene su orden original
      return 0;
    });

  return (
    <>
      <Header />
      {seriesFiltradas?.map(serie => <Serie key={serie.id} serie={serie} cuadros={cuadrosData} />)}
      <Spacing $size={32} />
      <Footer />
    </>
  );
};
